var React = require('react');
import { Link, browserHistory } from 'react-router';
// import {
//     XYPlot,
//   XAxis,
//   YAxis,
//   VerticalGridLines,
//   HorizontalGridLines,
//   HorizontalBarSeries,
//   HorizontalBarSeriesCanvas,
//   DiscreteColorLegend
// } from 'react-vis';
// import HSBar from "react-horizontal-stacked-bar-chart";

var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
// import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import '../../css/components/StudentAnalytics/ViewStudentConceptMap.css';

import ChartLabel from './chart-label';
import { Bar, HorizontalBar } from 'react-chartjs-2';

// import {
//   Highlight,
//   XYPlot
// } from 'react-vis';

// import { Pager } from 'react-bootstrap';

// import StudentsTable from './StudentsTable';
var StudentRes = require('../../resources/student');
var AnalyticsRes = require('../../resources/analytics');

const MATH_ID = 'a234e6f6-a3ee-4bfe-9143-5c52f89ac84c';
const SCIENCE_ID = '84c52703-3e79-4f8d-8376-d854093843c1';

const STUDENT_STATUSES = [{
  // title: 'Draft',
  // code: 'draft',
  // value: ['self'],
  // actions: ['edit', 'delete'],
  // count: '-',
  cols: ['firstName', 'lastName', 'email', 'phone', 'residentialAddress', 'schoolName', 'class', 'SA2Grade', 'parentName' ,'parentNo', 'parentEmail', 'lastActivityDate'],
  notes: [
    ''
  ]
}];

const ITEM_LIMIT = 20;

const STYLES = {
  SVG: {
    stroke: '#ddd',
    strokeWidth: '0.25',
    strokeOpacity: 0.5,
    textAlign:'center',
    fontSize:10,
    paddingOuter:32,
    margin:10
    // paddingInner:16
  },
  DOM: {
    // border: 'thin solid #ddd',
    stroke: '#ddd',
    strokeWidth: '0.25',
    strokeOpacity: 0.5,
    fontSize:10,
    // alignItems: 'center',
    // justifyContent: 'center',
    // paddingOuter:32,
    // margin:10,
    borderRadius:"100%",
    // display:'flex',
    position:'absolute',
  }
}

var ConceptMasteryBar = React.createClass({
// class ConceptMap extends React.Component { 

  // constructor(props) {
  //   super(props);
  // }

  componentWillReceiveProps: function(nextProps) {
    this.setState({
        // treeMapData:nextProps.treeMapData
        treeMapData: nextProps.barData || this.state.barData,
        originalData: nextProps.barData || this.state.barData,
        useCirclePacking: "circlePack",
        lastDrawLocation: null
    });
  },
  // getDefaultProps:function() {
  //   var _this = this;
  //       // console.log("TREEMAPDATA IS ",this.props.treeMapData);

  //   return {
  //       hoveredNode: false,
  //       treeMapData: this.props.treeMapData,
  //       useCirclePacking: false
  //     // conceptsMap: null,
  //   };
  // },
  
  getInitialState:function() {

    var _this = this;
    console.log("TREE MAP DATA IS ",this.props.barData);

    //convert the bar data into x and y data
    //x will be the numeric mastery score (e.g 99%)
    //y will be nothing (i.e "")
    var newBarData = [];
    var newLabels = [];
    var bgColors = [];
    // this.props.barData.forEach(eachBar => {

    //     var studentPercentage = Math.floor(eachBar.studentScore * 100);
    //     var remaining = 100 - studentPercentage;
    //     newBarData.push(studentPercentage);

    //     newLabels.push(eachBar.title);

    //     bgColors.push('green');
    // });

    // var newData = {
    //     labels: newLabels,
    //     datasets:[{
    //         data:newBarData,
    //         backgroundColor:bgColors
    //         // backgroundColor:'grey',
    //     }]
    // };
    // newBarData.push([
    //     {"value":studentPercentage,"color":"green"},
    //     {"value":remaining,"color":"grey","description":"" + studentPercentage+"%"}
    // ]);

    return {
        hoveredNode: false,
        barData: this.props.barData,
        originalData: this.props.barData,
        useCirclePacking: "circlePack",
        lastDrawLocation: null,
        previousLeafNode: null,
        barHeight:this.props.barHeight,
        masteryCategory:this.props.title,
        barColor:this.props.barColor
      // conceptsMap: null,
    };
  },

  componentDidMount:function() {

    var _this = this;
    // _this.setState({
    //     barData: _this.state.originalData
    // });
  },

  getHoveredNode: function(leafNode, domEvent) {

    var _this = this;
    // alert("test");
    // console.log("CALLED ZOOM IN OUT! X IS ",leafNode );
  },



  changeDisplayTitlesForMap:function() {

  },

  renderBars:function(eachBar) {
    
    var _this = this;
    // var barData = _this.state.barData;
    var maxWidth = 100;
    var bHeight = _this.state.height/(_this.state.barData.length);
    var bWidth = eachBar.studentScore * maxWidth;
    var percentage = Math.floor(eachBar.studentScore * 100) + '%';

    return (
      <div style={{
        width:120,
        height:bHeight,
        display:'flex',
        flexDirection:'row'
      }}>
        <div className="conceptTitle">{eachBar.title}</div>
        <div style={{
          backgroundColor:'grey',
          width:maxWidth,
          height:bHeight
        }}>
          <div style={{
            backgroundColor:'green',
            width:bWidth,
            height:bHeight
          }}>
            <div style={{ float:"right" }}>{percentage}</div>
          </div>
        </div>
      </div>
        // <HorizontalBar
        //     data={barData}
        //     // type={"horizontalBar"}
        //     width={100}
        //     height={_this.state.barHeight}
        //     options={{ 
        //         maintainAspectRatio: false,
        //         legend:false,
        //         scales: {
        //           xAxes: [{
        //             display:false
        //           }]
        //         }
        //     }}
        // />
    );
    // var returnRender = [];
    // barData.forEach(eachBar => {
    //     returnRender.push(
    //         <HSBar
    //       data={eachBar}/>
    //     )
    // }); 

    // return returnRender;
  },

  render:function() {
    var _this = this;

    // const {hoveredNode, useCirclePacking, lastDrawLocation} = _this.state;
    // const treeProps = {
    //   animation: {
    //     damping: 9,
    //     stiffness: 300
    //   },
    //   data: _this.state.barData,
    //   // onLeafMouseOver: x => _this.setState({hoveredNode: x}),
    //   // onLeafMouseOut: () => _this.setState({hoveredNode: false}),
    // //   onLeafClick: () => this.setState({treeMapData: _getRandomData()}),
    //   height: 300,
    //   mode: _this.state.useCirclePacking ? 'circlePack' : 'circlePack',
    //   getLabel: x => x.name,
    //   width: 350
    // };

    return (
        <div style={{
          width:'90%',
          height:_this.state.height,
          borderBottom:"1px dotted black",
          display:'flex',
          flexDirection:'row',
          marginBottom:'30px'
        }}>
          <div style={{
            display:'flex',
            flexDirection:'column',
            width:'90%'
          }}>
            {
              
              _this.state.barData.map(eachBarData => (

                // var maxWidth = 100;
                // var bHeight = _this.state.height/(_this.state.barData.length);
                // var bWidth = eachBar.studentScore * maxWidth;
                // var percentage = Math.floor(eachBar.studentScore * 100) + '%';
            
                <div className="masteryRowBar" style={{
                  width:'90%',
                  height:'20px',
                  display:'flex',
                  flexDirection:'row',
                  marginBottom:'20px'
                }}>
                  <div style={{width:'20%',textAlign:"right",paddingRight:'5px'}}>{eachBarData.title}</div>
                  <div className="masteryInnerBar" style={{
                    backgroundColor:'#e6e7e8',
                    width:'80%',
                    height:'20px',
                    display:'flex',
                    flexDirection:'row'
                  }}>
                    {/* <div style={{
                      backgroundColor:'none',
                      borderRight:"1px solid black",
                      width:(eachBarData.average * 100) * 800,
                      height:'20px',
                      float:'left'
                    }}></div> */}
                    <div style={{
                      backgroundColor:_this.state.barColor,
                      width:eachBarData.studentScore * 800,
                      height:'20px',
                      display:'flex',
                      flexDirection:'row'
                    }}>
                      
                    </div>
                    <span className="tooltiptext" style={{
                      left:(eachBarData.average * 100) * 800,
                      // marginTop:'-20px'
                    }}>
                      {"Avg Score: " + Math.floor(eachBarData.average * 100) + "%"}
                    </span>
                    <div style={{ float:"right" }}>{Math.floor(eachBarData.studentScore * 100) + '%'}</div>
                  </div>
                </div>
              ))
                // _this.state.barData.forEach(eachBarData => {
                //     <Bar
                //         data={eachBarData}
                //         type={"horizontalBar"}
                //         width={100}
                //         height={50}
                //         options={{ maintainAspectRatio: false }}
                //     />
                // })

                // _this.state.barData.forEach(eachBar => {
                //   _this.renderBars(eachBar);
                // })
            }
          </div>
          <div style={{ width:"50px"}}>
            {_this.state.masteryCategory}
          </div>
          
            {/* <Treemap 
              animation={{damping:9,stiffness:300}}
              onLeafMouseOver={ (x) => _this.setState({hoveredNode: x})}
              onLeafMouseOut={ () => _this.setState({hoveredNode: false})}
              onLeafClick={_this.zoomInOut.bind(_this)}
              data={_this.state.treeMapData}
              height={888}
              width={888}
              colorType={'literal'}
              //padding={2}
              //getLabel={x => x.name}
              style={STYLES['DOM']}
              mode={_this.state.useCirclePacking}
              renderMode={'DOM'}
             /> */}
        </div>
    );
  }

});

module.exports = ConceptMasteryBar;



/** WEBPACK FOOTER **
 ** ./src/components/StudentAnalytics/ConceptMasteryBar.js
 **/